import { render } from "./nCommentList.vue?vue&type=template&id=b3ba5b00&scoped=true"
import script from "./nCommentList.vue?vue&type=script&lang=js"
export * from "./nCommentList.vue?vue&type=script&lang=js"

import "./nCommentList.vue?vue&type=style&index=0&id=b3ba5b00&scoped=true&lang=css"

import exportComponent from "/Users/yxgc/Documents/workspace/BeeUiComentPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ba5b00"]])

export default __exports__